export var ModoEnum;
(function (ModoEnum) {
    ModoEnum["ONLINE"] = "ONLINE";
    ModoEnum["PRESENCIAL"] = "PRESENCIAL";
})(ModoEnum || (ModoEnum = {}));
